import React from "react";
import SelectInput from "./SelectInput";

function Categories({ podcastData, handleChange, categoriesList }) {
  function filterCategoriesList(currentId) {
    switch (currentId) {
      case "itunes_category1":
        return categoriesList.filter(
          (name) =>
            name !== podcastData.itunes_category2 &&
            name !== podcastData.itunes_category3
        );
      case "itunes_category2":
        return categoriesList.filter(
          (name) =>
            name !== podcastData.itunes_category1 &&
            name !== podcastData.itunes_category3
        );
      case "itunes_category3":
        return categoriesList.filter(
          (name) =>
            name !== podcastData.itunes_category1 &&
            name !== podcastData.itunes_category2
        );
      default:
        break;
    }
  }

  return (
    <>
      {categoriesList && (
        <div className="flex-1">
          {categoriesList.length === 0 ? (
            <>
              <p className="text-gray-700">Primary Category</p>
              <p className="text-base bg-gray-100 input">Loading...</p>
            </>
          ) : (
            <SelectInput
              handleChange={(e) => {
                handleChange("itunes_category1", e.target.value);
              }}
              selectedCategory={podcastData.itunes_category1}
              name="primaryCategory"
              title="Primary Category"
              showLabel={true}
            >
              <option defaultValue value="">
                Pick a category
              </option>
              {filterCategoriesList("itunes_category1").map(
                (categoryName) => (
                  <option key={categoryName} value={categoryName}>
                    {categoryName}
                  </option>
                )
              )}
            </SelectInput>
          )}
        </div>
      )}

      <p className="mt-8 text-gray-500">
        Optionally add a secondary and tertiary category to boost your shows
        visibility.
      </p>
      <div className="flex flex-col gap-4 mt-5 sm:flex-row sm:items-center">
        <div className="flex-1">
          {categoriesList.length === 0 ? (
            <>
              <p className="text-gray-700">Secondary Category (Optional)</p>
              <p className="text-base bg-gray-100 input">Loading...</p>
            </>
          ) : (
            <SelectInput
              handleChange={(e) => {
                handleChange("itunes_category2", e.target.value);
              }}
              selectedCategory={podcastData.itunes_category2}
              name="secondaryCategory"
              title="Secondary Category (Optional)"
              showLabel={true}
            >
              <option defaultValue value="">
                Pick a category
              </option>
              {filterCategoriesList("itunes_category2").map(
                (categoryName) => (
                  <option key={categoryName} value={categoryName}>
                    {categoryName}
                  </option>
                )
              )}
            </SelectInput>
          )}
        </div>
        <div className="flex-1">
          {categoriesList.length === 0 ? (
            <>
              <p className="text-gray-700">Tertiary Category (Optional)</p>
              <p className="text-base bg-gray-100 input">Loading...</p>
            </>
          ) : (
            <SelectInput
              handleChange={(e) => {
                handleChange("itunes_category3", e.target.value);
              }}
              selectedCategory={podcastData.itunes_category3}
              name="tertiaryCategory"
              title="Tertiary Category (Optional)"
              showLabel={true}
            >
              <option defaultValue value="">
                Pick a category
              </option>
              {filterCategoriesList("itunes_category3").map(
                (categoryName) => (
                  <option key={categoryName} value={categoryName}>
                    {categoryName}
                  </option>
                )
              )}
            </SelectInput>
          )}
        </div>
      </div>
    </>
  );
}

export default Categories;
